import { tgxApi } from "../../../app/tgxApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/utils/RtkQueryUtils";
import { serialize } from "../../../helpers/utils/Utils";

export const reswareApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchReswareCredentials: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/get-all-resWare-Credentials?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['reswareCredentials'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        searchReswareTypeMappings: build.query({
            query: (params) => ({
                url: `/ajax/get-all-resWare-type-map?${serialize(params)}`,
                method: 'GET',
                headers: getAuthorizationHeader(),
            }),
            providesTags: ['reswareTypeMappings'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        createReswareCredential: build.mutation({
            query: ({ id, data }) => ({
                url: `/ajax/create/resWare-Credential/${id}`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: data,
            }),
            invalidatesTags: ['reswareCredentials', 'reswareTypeMappings'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Resware Credential");
            },
        }),

        updateReswareCredential: build.mutation({
            query: ({ id, data }) => ({
                url: `/ajax/update/resware-credential/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: data,
            }),
            invalidatesTags: ['reswareCredentials', 'reswareTypeMappings', 'reswareTypeCredentialsById'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Resware Credential");
            },
        }),

        createReswareTypeMapping: build.mutation({
            query: ({ id, data }) => ({
                url: `/ajax/create/resWare-type-map/${id}`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: data,
            }),
            invalidatesTags: ['reswareCredentials', 'reswareTypeMappings'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Resware Type Mapping");
            },
        }),

        updateReswareTypeMapping: build.mutation({
            query: ({ id, data }) => ({
                url: `/ajax/update/resware-type-map/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: data,
            }),
            invalidatesTags: ['reswareCredentials', 'reswareTypeMappings', 'reswareTypeMappingsById'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Resware Type Mapping");
            },
        }),

        getReswareCredentialById: build.query({
            query: ({ customerId, credentialId }) => ({
                url: `/ajax/get-resWare-Credentials-by-id/${customerId}/${credentialId}`,
                method: 'GET',
                headers: getAuthorizationHeader(),
            }),
            providesTags: ["reswareTypeCredentialsById"],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        getReswareTypeMappingById: build.query({
            query: ({ customerId, mappingId }) => ({
                url: `/ajax/get-resWare-type-map-by-id/${customerId}/${mappingId}`,
                method: 'GET',
                headers: getAuthorizationHeader(),
            }),
            providesTags: ["reswareTypeMappingsById"],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        deleteReswareCredential: build.mutation({
            query: ({ customerId, credentialId }) => ({
                url: `/ajax/delete/resWare-Credential/${customerId}/${credentialId}`,
                method: 'DELETE',
                headers: getAuthorizationHeader(),
            }),
            invalidatesTags: ['reswareCredentials'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Resware Credential");
            },
        }),
        deleteReswareTypeMapping: build.mutation({
            query: ({ customerId, mappingId }) => ({
                url: `/ajax/delete/resWare-type-map/${customerId}/${mappingId}`,
                method: 'DELETE',
                headers: getAuthorizationHeader(),
            }),
            invalidatesTags: ['reswareTypeMappings'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Resware Type Mapping");
            },
        }),
    }),
});

export const {
    useSearchReswareCredentialsQuery,
    useSearchReswareTypeMappingsQuery,
    useCreateReswareCredentialMutation,
    useUpdateReswareCredentialMutation,
    useGetReswareCredentialByIdQuery,
    useDeleteReswareCredentialMutation,
    useUpdateReswareTypeMappingMutation,
    useCreateReswareTypeMappingMutation,
    useGetReswareTypeMappingByIdQuery,
    useDeleteReswareTypeMappingMutation,
} = reswareApi;
